import { INDUSTRIES_BASE, SLUGS, industryPath } from "./industryRoutes";
export const navigation = [
  {
    label: "Solutions",
    columns: [
      {
        heading: "AI Services",
        href: "/ai-infrastructure",
        items: [
          {
            label: "AI Data Operations & Human-In-The-Loop Services",
            href: "/ai-infrastructure/ai-data-operations",
            description:
              "Annotation and quality workflows backed by expert human review.",
          },
          {
            label: "Data Collection",
            href: "/ai-infrastructure/data-collection",
            description:
              "Custom, compliant datasets sourced across data types.",
          },
          {
            label: "Generative AI",
            href: "/ai-infrastructure/generative-ai",
            description: "Training and evaluation data for generative models.",
          },
          {
            label: "Sports",
            href: "https://www.qualitasglobalsports.com/",
            external: true,
            description: "Sports tagging, tracking and analytics services.",
          },
        ],
      },
      {
        heading: "Business Solutions",
        href: "/global-capability",
        items: [
          {
            label: "Build-Operate-Transfer (BOT) / Lean GCC",
            href: "/global-capability/bot-lean-gcc",
            description:
              "Build, operate and transfer your own capability centre.",
          },
          {
            label: "Knowledge Process Outsourcing (KPO)",
            href: "/global-capability/kpo",
            description: "Research, analysis and domain-led knowledge work.",
          },
          {
            label: "Business Process Outsourcing (BPO)",
            href: "/global-capability/bpo",
            description: "Scalable back-office and process operations.",
          },
          {
            label: "Dedicated Staffing",
            href: "/global-capability/dedicated-staffing",
            description: "Dedicated teams that work as an extension of yours.",
          },
        ],
      },
      {
        heading: "Products",
        items: [
          {
            label: "AI Data Platform",
            href: "https://qualitasglobal.ai/",
            external: true,
            description: "Our platform for managing and annotating AI data.",
          },
        ],
      },
    ],
  },

  {
    // No top-level href: the menu label only opens the dropdown.
    // The main industries page is reached through `overview` inside the dropdown.
    label: "Domain Expertise",
    overview: {
      label: "Explore all industries",
      href: INDUSTRIES_BASE,
      description: "Browse every industry we serve in one place.",
    },
    columns: [
      {
        heading: "Mobility & Transport",
        items: [
          {
            label: "ADAS & Autonomous Vehicles",
            href: industryPath(SLUGS.adas),
          },
          {
            label: "Aerial & Drones: Imaging & Surveying",
            href: industryPath(SLUGS.aerialDrones),
          },
          { label: "Marine & Maritime", href: industryPath(SLUGS.marine) },
          { label: "Logistics", href: industryPath(SLUGS.logistics) },
          { label: "Robotics", href: industryPath(SLUGS.robotics) },
        ],
      },
      {
        heading: "Industry & Infrastructure",
        items: [
          { label: "Manufacturing", href: industryPath(SLUGS.manufacturing) },
          { label: "Construction", href: industryPath(SLUGS.construction) },
          { label: "Energy & Utilities", href: industryPath(SLUGS.energy) },
          {
            label: "Agri-Tech, Precision Agriculture & Livestock",
            href: industryPath(SLUGS.agriTech),
          },
          {
            label: "Geospatial & Satellite: Imaging & Mapping",
            href: industryPath(SLUGS.geospatial),
          },
        ],
      },
      {
        heading: "Business & Consumer",
        items: [
          {
            label: "Banking, Financial Services & Insurance",
            href: industryPath(SLUGS.bfsi),
          },
          {
            label: "Fashion, Retail & E-commerce",
            href: industryPath(SLUGS.fashion),
          },
          {
            label: "Hospitality & Tourism",
            href: industryPath(SLUGS.hospitality),
          },
          { label: "Education", href: industryPath(SLUGS.education) },
          {
            label: "Healthcare, Health-Tech & Biological",
            href: industryPath(SLUGS.healthcare),
          },
        ],
      },
      {
        heading: "Public, Media & Tech",
        items: [
          {
            label: "Defense, Security & Surveillance",
            href: industryPath(SLUGS.defence),
          },
          {
            label: "Government, Public Sector & Smart Cities",
            href: industryPath(SLUGS.government),
          },
          {
            label: "Gaming, Entertainment & Media",
            href: industryPath(SLUGS.gaming),
          },
          { label: "Sports Analytics", href: industryPath(SLUGS.sports) },
          {
            label: "Technology & Telecommunications",
            href: industryPath(SLUGS.tech),
          },
        ],
      },
    ],
  },

  {
    label: "Company",
    columns: [
      {
        heading: "About",
        items: [
          {
            label: "About Us",
            href: "/about-us",
            description: "Who we are, what we do and how we work.",
          },
          {
            label: "Careers",
            href: "/careers",
            description: "Open roles and life at Qualitas Global.",
          },
        ],
      },
      {
        heading: "Insights",
        items: [
          {
            label: "Blogs",
            href: "/resources/blogs",
            description: "Articles on data, annotation and applied AI.",
          },
          {
            label: "Media",
            href: "/resources/media",
            description: "Press coverage, interviews and recognition.",
          },
        ],
      },
    ],
  },
];
